import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FormField } from '@/models';

interface PasswordValidation {
  hasEightChars: boolean;
  hasUppercaseLetter: boolean;
  hasLowercaseLetter: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
}

@Component({
  name: 'CmgPasswordInput',
})
export default class CmgPasswordInput extends Vue {
  showPasswordTooltip = false;
  passwordRequirements: PasswordValidation =  { 
    hasEightChars: false, 
    hasUppercaseLetter: false, 
    hasLowercaseLetter: false, 
    hasNumber: false, 
    hasSpecialChar: false 
  };

  @Prop({ required: true, type: Object })
  password!: FormField;

  mounted() {
    this.validatePasswordOnInput(this.password.value);
  }

  onFocusPassword() {
    this.showPasswordTooltip = true;
  }

  onBlurPassword() {
    this.showPasswordTooltip = false;
  }

  validatePassword(): void {
    this.$emit('validate-password');
  }

  validatePasswordOnInput(password: string): string {
    this.passwordRequirements = this.passwordValidation(password);
    return password;
  }

  passwordValidation(password: string): PasswordValidation {
    return {
      hasEightChars: /(?=.{8,50}$)/.test(password),
      hasUppercaseLetter: /(?=.*[A-Z])/.test(password),
      hasLowercaseLetter: /(?=.*[a-z])/.test(password),
      hasNumber: /(?=.*[0-9])/.test(password),
      hasSpecialChar: /(?=.*[!"#\\$%&'()*+,-.:;<=>?@[\]\^_`{|}~])/.test(password),
    };
  }
}
